import styled from 'styled-components'

export const IconWrapper = styled.div`
  position: absolute;
  right: 4px;
  display: flex;
  height: 100%;
  width: 15px;
  align-items: center;
  justify-content: center;
`
